import { render, staticRenderFns } from "./value.vue?vue&type=template&id=ffce1b94&scoped=true&"
import script from "./value.vue?vue&type=script&lang=js&"
export * from "./value.vue?vue&type=script&lang=js&"
import style0 from "./value.vue?vue&type=style&index=0&id=ffce1b94&prod&scoped=true&lang=less&"
import style1 from "./value.vue?vue&type=style&index=1&id=ffce1b94&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffce1b94",
  null
  
)

export default component.exports